import {
  BatchCollectionMgmtCollectionBulkRemovalConditionListItem,
  BatchCollectionMgmtCollectionBulkRemovalConditionListItemFromJSON
} from '@/api/models/batch/BatchCollectionMgmtCollectionBulkRemovalConditionListItem'

export interface BatchCollectionMgmtCollectionBulkRemovalPageLoadResult {
  items: BatchCollectionMgmtCollectionBulkRemovalConditionListItem
}

export function BatchCollectionMgmtCollectionBulkRemovalPageLoadResultFromJSON(
  json: any
): BatchCollectionMgmtCollectionBulkRemovalPageLoadResult {
  return {
    items: BatchCollectionMgmtCollectionBulkRemovalConditionListItemFromJSON(
      json
    )
  }
}
